import * as dataStore from './DataStore';
import GoodReads from '../models/GoodReads';

/**
* @returns a GoodReads object
*/
export function getGoodReads() {
    const goodReads = dataStore.getJsonData().FeatureContent.GoodReads;
    if (goodReads) {
        return new GoodReads(goodReads);
    }
}


// WEBPACK FOOTER //
// ./src/data/GoodReadsSelector.js